import { registerDOMRenderer, createReactRenderer, } from '@byted/light-render/lib/utils/dom-renderer';
import { DOMNode, Text, RichText } from '../element/index';
var jsxRegistered = false;
export function setJSXRenderer(ReactDOM) {
    jsxRegistered = true;
    registerDOMRenderer('jsx', createReactRenderer(ReactDOM));
}
export function isRichFormat(content) {
    var _a;
    return !!((_a = content) === null || _a === void 0 ? void 0 : _a.RICH_TYPE);
}
export function html(templateStrings) {
    var insertVars = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        insertVars[_i - 1] = arguments[_i];
    }
    return {
        RICH_TYPE: 'html',
        content: templateStrings.reduce(function (res, temp, i) {
            return res + temp + (i >= insertVars.length ? '' : insertVars[i]);
        }, ''),
    };
}
export function xul(templateStrings) {
    var insertVars = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        insertVars[_i - 1] = arguments[_i];
    }
    return {
        RICH_TYPE: 'xul',
        content: templateStrings.reduce(function (res, temp, i) {
            return res + temp + (i >= insertVars.length ? '' : insertVars[i]);
        }, ''),
    };
}
export function xulObj(json) {
    return {
        RICH_TYPE: 'xul',
        content: json,
        json: true,
    };
}
export function jsx(element, ReactDOM) {
    return {
        RICH_TYPE: 'jsx',
        content: element,
        ReactDOM: ReactDOM,
    };
}
export function createRichText(conf) {
    var _a;
    var formatType = (_a = conf.text) === null || _a === void 0 ? void 0 : _a.RICH_TYPE;
    if (!conf.rich && !formatType) {
        return new Text(conf);
    }
    var richType = formatType || conf.rich;
    conf.renderer = richType;
    if (isRichFormat(conf.text)) {
        if (conf.text.RICH_TYPE === 'jsx' && conf.text.ReactDOM && !jsxRegistered) {
            setJSXRenderer(conf.text.ReactDOM);
        }
        conf.text = conf.text.content;
    }
    if (richType === 'html' || richType === 'jsx') {
        return new DOMNode(conf);
    }
    return new RichText(conf);
}
